exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".photosDisplay .zeroHeader{margin-bottom:3%}.photosDisplay .photos{margin-top:8%}.photosDisplay .owlstagramLink{margin-bottom:20px}.photosDisplay .samplePhoto{opacity:.6;filter:grayscale(80%)}.photosDisplay .photoBox{display:inline-block;width:31%;margin-left:1.165%;margin-right:1.165%}.photosDisplay .photoBox .textHeader{font-size:.8em;color:#888;margin-bottom:5px}.photosDisplay .photoBox img.photo{width:100%;margin-bottom:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/social/photos/photos_display.scss
// module id = 1410
// module chunks = 0